import React, { lazy, Suspense } from "react";
import { Row } from "react-bootstrap";

const GitHubCalendar = lazy(() => import("react-github-calendar"));

const rowStyle = {
  justifyContent: "center",
  paddingBottom: "10px",
  color: "white",
};

const GITHUB_USERNAME = "iamdheerajjain";

const calendarConfig = {
  blockSize: 30,
  blockMargin: 10,
  color: "#ff3b3f",
  fontSize: 20,
};

const calendarFallbackStyle = {
  minHeight: "180px",
  width: "100%",
};

function Github() {
  return (
    <Row style={rowStyle}>
      <h1 className="project-heading pb-4">
        Days I <strong className="purple">Code</strong>
      </h1>
      <Suspense fallback={<div style={calendarFallbackStyle} />}>
        <GitHubCalendar username={GITHUB_USERNAME} {...calendarConfig} />
      </Suspense>
    </Row>
  );
}

export default React.memo(Github);
